module.exports = {
    dialog: {
        tip: 'ヒント'
    },
    table: {
        emptyText: 'データなし'
    },
    pagination: {
        pre: '前のページへ',
        next: '次のページへ',
        totalPage: '{total}ページ',
        to: '',
        page: 'ページへ',
        sure: '確定',
        validMsg: {
            inputRule: '正の整数を入力してください'
        }
    },
    dropdown: {
        menu: 'ドロップダウンメニュー',
    },
    errPage: {
        accessError: 'あ〜このサイトにアクセスできません',
        error404: 'あ〜あなたが訪れたページは存在しません',
        backHome: 'トップに戻る',
        backPre: '前のページに戻る',
        tryMethod: '以下の方法をお試しください：',
        checkOpt: ['ネットワークを確認してください', 'サービスが正常に動作しているかどうかを確認してください']
    },
    labelSize: {
        screenInfos: [{
            key: '0001',
            value: '1.54"(152*152) 黒白',
            size: '1.54',
            resolution: '152*152',
            rotate: '左に90度回転',
            color: 'black',
            temperature: ''
        }, {
            key: '0002',
            value: '2.13"(212*104) 黒白',
            size: '2.13',
            resolution: '212*104',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0003',
            value: '2.13"(250*122) 黒白',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0004',
            value: '2.9"(296*128) 黒白',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'black',
            temperature: ''
        }, {
            key: '0005',
            value: '4.2"(400*300) 黒白',
            size: '4.2',
            resolution: '400*300',
            rotate: '左に90度回転',
            color: 'black',
            temperature: ''
        }, {
            key: '0006',
            value: '1.54"(152*152) 黒白赤',
            size: '1.54',
            resolution: '152*152',
            rotate: '左に90度回転',
            color: 'red',
            temperature: ''
        }, {
            key: '0007',
            value: '1.54"(152*152) 黒白黄',
            size: '1.54',
            resolution: '152*152',
            rotate: '左に90度回転',
            color: 'yellow',
            temperature: ''
        }, {
            key: '0008',
            value: '2.13"(250*122) 黒白赤',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0009',
            value: '2.13"(250*122) 黒白黄',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000a',
            value: '2.9"(296*128) 黒白赤',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '000b',
            value: '2.9"(296*128) 黒白黄',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000c',
            value: '4.2"(400*300) 黒白赤',
            size: '4.2',
            resolution: '400*300',
            rotate: '左に90度回転',
            color: 'red',
            temperature: ''
        }, {
            key: '000d',
            value: '4.2"(400*300) 黒白黄',
            size: '4.2',
            resolution: '400*300',
            rotate: '左に90度回転',
            color: 'yellow',
            temperature: ''
        }, {
            key: '000e',
            value: '2.13"(250*122) 低温黒白',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'black',
            temperature: 'low'
        }, {
            key: '000f',
            value: '5.83"(648*480) 黒白赤',
            size: '5.83',
            resolution: '648*480',
            rotate: '左に90度回転',
            color: 'red',
            temperature: ''
        }, {
            key: '0010',
            value: '7.5"(880*528) 黒白赤',
            size: '7.5',
            resolution: '880*528',
            rotate: '左に90度回転',
            color: 'red',
            temperature: ''
        }, {
            key: '0011',
            value: '2.66"(296*152) 黒白赤',
            size: '2.66',
            resolution: '296*152',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0012',
            value: '1.54"(200*200) 黒白赤',
            size: '1.54',
            resolution: '200*200',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0013',
            value: '2.13"(250*122) 黒白赤',
            size: '2.13',
            resolution: '250*122',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0014',
            value: '2.9"(296*128) 黒白赤',
            size: '2.9',
            resolution: '296*128',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '0015',
            value: '4.2"(400*300) 黒白赤',
            size: '4.2',
            resolution: '400*300',
            rotate: '',
            color: 'red',
            temperature: ''
        },{
            key: '0017',
            value: '11.6"(960*640) 黒白赤',
            size: '11.6',
            resolution: '960*640',
            rotate: '',
            color: 'red',
            temperature: ''
        }, {
            key: '8000',
            value: '画面が破損している',
            size: '',
            resolution: '',
            rotate: '',
            color: '',
            temperature: ''
        }]
    },
    allLabelTypeDatas: [{ //树形组件  标签条件查询
            id: '1.54_a',
            label: '1.54 "',
            children: [{
                id: '1.54_b',
                label: '1.54" 黒白'
            }, {
                id: '1.54_r',
                label: '1.54" 黒白赤'
            }, {
                id: '1.54_y',
                label: '1.54" 黒白黄'
            }]
        }, {
            id: '2.13_a',
            label: '2.13"',
            children: [{
                id: '2.13_b',
                label: '2.13" 黒白'
            }, {
                id: '2.13_r',
                label: '2.13" 黒白赤'
            }, {
                id: '2.13_y',
                label: '2.13" 黒白黄'
            }, {
                id: '2.13_b_low',
                label: '2.13" 低温黒白'
            }]
        },
        {
            id: '2.66_a',
            label: '2.66"',
            disabled: true,
            children: [{
                id: '2.66_b',
                label: '2.66" 黒白',
                disabled: true
            }, {
                id: '2.66_r',
                label: '2.66" 黒白赤'
            }, {
                id: '2.66_y',
                label: '2.66" 黒白黄',
                disabled: true
            }]
        }, 
        {
            id: '2.9_a',
            label: '2.9"',
            children: [{
                id: '2.9_b',
                label: '2.9" 黒白'
            }, {
                id: '2.9_r',
                label: '2.9" 黒白赤'
            }, {
                id: '2.9_y',
                label: '2.9" 黒白黄'
            }]
        }, {
            id: '4.2_a',
            label: '4.2"',
            children: [{
                id: '4.2_b',
                label: '4.2" 黒白'
            }, {
                id: '4.2_r',
                label: '4.2" 黒白赤'
            }, {
                id: '4.2_y',
                label: '4.2" 黒白黄'
            }]
        }, {
            id: '5.83_a',
            label: '5.83"',
            disabled: true,
            children: [{
                id: '5.83_b',
                label: '5.83" 黒白',
                disabled: true
            }, {
                id: '5.83_r',
                label: '5.83" 黒白赤',
                // disabled: true
            }, {
                id: '5.83_y',
                label: '5.83" 黒白黄',
                disabled: true
            }]
        }, {
            id: '7.5_a',
            label: '7.5"',
            disabled: true,
            children: [{
                id: '7.5_b',
                label: '7.5" 黒白',
                disabled: true
            }, {
                id: '7.5_r',
                label: '7.5" 黒白赤',
                // disabled: true
            }, {
                id: '7.5_y',
                label: '7.5" 黒白黄',
                disabled: true
            }]
        }, {
            id: '11.6_a',
            label: '11.6"',
            disabled: true,
            children: [{
                id: '11.6_b',
                label: '11.6" 黒白',
                disabled: true
            }, {
                id: '11.6_r',
                label: '11.6" 黒白赤',
                // disabled: true
            }, {
                id: '11.6_y',
                label: '11.6" 黒白黄',
                disabled: true
            }]
        }
    ],
    // excelComment: '条形码长度固定为13位数字',
    // excelComment: 'IDは文字または番号字で構成されています',
    excelComment: {
        id: 'IDは文字または番号字で構成されています',
        qrcode: 'QRコードシステムは、IDに従って自動的に生成されるため、入力する必要はありません。入力された場合でも、システムで自動生成されたQRコードを使用してください'
    },
    labelPreview: {
        loadErr: '画像を読み込めませんでした',
        chooseImg: '描く絵を選んでください',
        brErr: 'バーコードには数字または文字を入力してください。入力しないと表示できません',
        brErr1: 'バーコードには13桁を入力してください。それ以外の場合は表示できません'
    },
    viewPermis: {
        demo: 'このストアのテンプレート関連のページを表示する権限がありません',
        editDemo: 'ストアのテンプレートを編集する権限がありません',
        sysDemo: 'システムテンプレート関連ページを表示する権限がありません',
        system: 'システムページを表示する権限がありません',
        errcode: 'エラーコードページを表示する権限がありません',
        shopSetting: 'ストアの設定ページを表示する権限がありません',
        hasStore: 'あなたはストアのメンバーではないため、ストアデータを表示できません。管理者に連絡してストアを割り当ててください',
        storeClose: 'あなたが見ている店は閉まっています'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/ja/common.js